const axios = require('axios');
export const initNumberFormatSetting = (column) => {
    column.getElement().querySelectorAll('.ac-column-setting--number_format').forEach(setting => {
        new NumberFormat(column, setting);
    });
};
class NumberFormat {
    constructor(column, setting) {
        this.column = column;
        this.setting = setting;
        this.bindEvents();
    }
    bindEvents() {
        this.refreshPreview();
        this.setting.querySelectorAll('input').forEach(el => {
            el.addEventListener('change', () => this.refreshPreview());
        });
    }
    refreshPreview() {
        this.getExampleRequest().then((response) => {
            this.setting.querySelectorAll('[data-preview]').forEach(el => el.textContent = response.data.data);
        });
    }
    getValue() {
        let decimals = this.setting.querySelector('.ac-setting-input_number_decimals');
        let decimal_point = this.setting.querySelector('.ac-setting-input_number_decimal_point');
        let thousands_point = this.setting.querySelector('.ac-setting-input_number_thousands_separator');
        return {
            decimals: decimals ? decimals.value : '',
            decimal_point: decimal_point ? decimal_point.value : '',
            thousands_point: thousands_point ? thousands_point.value : '',
        };
    }
    getExampleRequest() {
        const value = this.getValue();
        let data = new FormData();
        data.set('action', 'ac_number_format');
        data.set('number', '7500');
        data.set('decimals', value.decimals);
        data.set('decimal_point', value.decimal_point);
        data.set('thousands_sep', value.thousands_point);
        return axios.post(ajaxurl, data, {});
    }
}
